var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup3465375(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.77771 6.54589C5.6931 7.44839 5.63373 9.04558 6.16662 9.72542C6.16662 9.72542 5.91576 7.97089 8.16459 5.76956C9.07006 4.88339 9.27935 3.67808 8.96318 2.77409C8.78357 2.26198 8.45553 1.83894 8.17053 1.54355C8.00428 1.36987 8.13193 1.08339 8.37389 1.09378C9.83748 1.15909 12.2095 1.56581 13.2174 4.09519C13.6597 5.2055 13.6924 6.35292 13.4816 7.51964C13.348 8.2648 12.873 9.92136 13.9566 10.1247C14.73 10.2702 15.104 9.65566 15.2718 9.21331C15.3415 9.02925 15.5835 8.98323 15.7141 9.13019C17.0204 10.616 17.1317 12.3661 16.8615 13.8728C16.339 16.7851 13.3896 18.9048 10.4594 18.9048C6.79896 18.9048 3.88514 16.8103 3.12959 13.0192C2.82529 11.4889 2.97967 8.46073 5.33982 6.32323C5.51498 6.16292 5.80146 6.30542 5.77771 6.54589Z",
    fill: "url(#paint0_radial_707_16833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7972 11.9921C10.4479 10.2554 11.052 8.27371 11.3831 7.48402C11.4276 7.38012 11.3088 7.28215 11.2153 7.34598C10.6349 7.74082 9.44594 8.67004 8.89227 9.97777C8.14266 11.7457 8.1961 12.6111 8.63993 13.6679C8.90711 14.3047 8.59688 14.4398 8.44102 14.4636C8.28961 14.4873 8.15008 14.3864 8.03875 14.281C7.71848 13.9735 7.49025 13.5828 7.37969 13.1529C7.35594 13.0608 7.23571 13.0356 7.18079 13.1113C6.76516 13.6857 6.54993 14.6075 6.53954 15.2592C6.50688 17.2735 8.17086 18.9063 10.1837 18.9063C12.7205 18.9063 14.5685 16.1008 13.1109 13.7555C12.6878 13.0727 12.29 12.6259 11.7972 11.9921Z",
    fill: "url(#paint1_radial_707_16833)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_707_16833",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.73443 18.9509) rotate(-179.751) scale(10.4779 17.1921)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#F44336"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_707_16833",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3232 8.52433) rotate(90.5787) scale(10.9631 8.25053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#FFF176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF27D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#FFF48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFF7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#FFF9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#FFF8BD",
    stopOpacity: 0.804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#FFF6AB",
    stopOpacity: 0.529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFF38D",
    stopOpacity: 0.209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#FFF176",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3465375);
export default __webpack_public_path__ + "static/media/Group 3465375.715072b05047f877c47cb6c3ab8dc879.svg";
export { ForwardRef as ReactComponent };